export const summaryPanelClass = 'w-full p-xs border-0 rounded-md bg-surface text-fg shadow-card'

export const summaryPanelHeaderClass = 'flex flex-wrap items-center justify-between gap-sm'

export const summaryPanelTitleClass = '!m-0 !text-primary !text-xl !font-semibold !leading-7'

export const summaryPanelTabsClass = '!hidden'

export const summaryPanelActionsClass = 'flex items-center justify-end gap-sm'

export const summaryPanelDetailsClass =
  'inline-flex flex-none items-center gap-1.5 text-info text-xs font-bold no-underline transition-colors duration-150 hover:text-primary'

export const summaryPanelSelectClass = 'min-w-40'
